import {
  ProgressFetchXHR,
  TrackedTaskName,
  type TrackingCallback,
} from "@pdfking/pdfengine"

import track_promise from "./track_promise"

export default (url: string, data = {}): Promise<Response> =>
  track_promise((emit: TrackingCallback) =>
    ProgressFetchXHR(url, data, {
      download: e =>
        emit({
          name: TrackedTaskName.DOWNLOAD,
          ...e,
        }),
      upload: e =>
        emit({
          name: TrackedTaskName.UPLOAD,
          ...e,
        }),
    })
  )
